
import React, { createContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ProjectsActions from '../Redux/Actions/ProjectsActions';
import InterfaceActions from '@/Redux/Actions/InterfaceActions';
import useTranslation from './UseTranslation';
import { useQuery } from './UseQuery';

import { getNonWorkingDays } from '@/Helpers/ProgrammationHelper';

interface ProjectProps {
  project_id: string;
  project: any;
  nonWorkingDays: string[];
  projectLoaded: boolean;
  loadProject: () => void;
  saveProject: (patch: any) => void;
}


const ProjectContext = createContext<ProjectProps | undefined>(undefined)

export const ProjectProvider = ({ children }: { children: React.ReactNode }) => {

  const { t } = useTranslation()

  const query = useQuery();

  const dispatch = useDispatch()

  const location = useLocation();

  const pathname = location.pathname;

  let project_id = pathname.split('/')[2]
  const isProjectRoute = pathname.split('/')[1] === 'project'

  if (!project_id) {

    project_id = query.get("project_id") || '';
  }

  const project = useSelector((state: any) => state.ProjectsReducer.rowData)
  const projectLoaded = useSelector((state: any) => state.ProjectsReducer.loadRowStatus === 'loaded')

  const loadProject = async () => {

    await dispatch(ProjectsActions.getRowAction(project_id))
  }

  const nonWorkingDays = useMemo(() => {

    if (!project._id) return []

    return getNonWorkingDays(project.startsAt, project.endsAt, project)
  }, [ project._id, project.nonWorkingDays ])

  const saveProject = async (project: any) => {

    dispatch(InterfaceActions.showLoader())

    await dispatch(ProjectsActions.updateAction(project))

    dispatch(InterfaceActions.hideLoader())
  }

  useEffect(() => {

    if (project_id && isProjectRoute) {

      loadProject()
    }
    return () => {
      dispatch(ProjectsActions.clearProjectAction())
    }
  }, [project_id, isProjectRoute])

  const value: ProjectProps = {
    project_id,
    project,
    projectLoaded,
    nonWorkingDays,
    loadProject,
    saveProject,
  }

  return (
    <ProjectContext.Provider value={value}>
      {children}
    </ProjectContext.Provider>
  )
}

export const useProject = (): ProjectProps => {

  const context = React.useContext(ProjectContext)

  if (context === undefined) {
    throw new Error('useProject must be used within a ProjectProvider')
  }

  return context
}
